document.addEventListener('DOMContentLoaded', function() {
  if (!window.mz) {
    return
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  function afterUpdate() {
    $('body').find('.js-toggleSearchForm').removeClass('is-open');
    $('body').find('.js-toggleSearchBtn').removeClass('is-open');
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
  }
})
